export const OPTHINES = {
  voteName: '2019poject/2019ljby',
  mustSearch: 'Button',
  buttonBg: '#d83334',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  tickets: {
    textFirst: '赞数',
    textLast: '赞',
  },
  checkBox: false,
  // hasVoteButton: {
  //   text: '点赞',
  //   textColor: '#fff',
  //   themeColor: '#fe4d57',
  // },
  themeColor: {
    activeBgColor: '#356fe5',
    inactiveBgColor: '#f1f1f1',
  },
  tabs: [
    {
      tabName: '候选人投票',
      tabPath: '/2019LJBY/List',
    },

    {
      tabName: '报名通道',
      tabPath: '/2019LJBY/JumpPage?type=1',
    },
    {
      tabName: '榜样展示',
      tabPath: '/2019LJBY/JumpPage?type=2',
    },

    {
      tabName: '两江故事',
      tabPath: '/2019LJBY/JumpPage?type=3',
    },
    {
      tabName: '活动规则',
      tabPath: '/2019LJBY/JumpPage?type=4',
    },
    // {
    //   tabName: '我要报名',
    //   tabPath: '/2019HandcraftPaper/Register',
    // },
  ],
};
